import { render, staticRenderFns } from "./coperSetting.vue?vue&type=template&id=7bfc53ca&scoped=true&"
import script from "./coperSetting.vue?vue&type=script&lang=js&"
export * from "./coperSetting.vue?vue&type=script&lang=js&"
import style0 from "./coperSetting.vue?vue&type=style&index=0&id=7bfc53ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfc53ca",
  null
  
)

export default component.exports